<template>
  <v-row dense>
    <v-col cols="12">
      <v-text-field
        v-model="form.title"
        name="title"
        counter="65"
        :label="`${$t('ITEM.TITLE')} *`"
        :readonly="readonly"
        :error-messages="errors.title"
        :rules="getRulesByName('title')"
        @input="updateValue('title', $event)"
      />
    </v-col>
    <date-picker-select
      v-model="form"
      :errors="errors"
      @input="emitter"
      @update-prop="updateProp(...arguments)"
    />

    <v-col cols="12">
      <v-row dense>
        <v-checkbox
          :value="specifyRegions"
          hide-details
          class="mb-4"
          dense
          :label="$t('HOLIDAY.SPECIFY_REGIONS')"
          @change="changeRegions"
        />
        <v-spacer />
      </v-row>

      <region-input
        v-if="specifyRegions"
        v-model="form.regions"
        :rules="getRulesByName('regions')"
        :error-messages="errors.regions"
        :label="$t('REGIONS.ITEM')"
        @input="updateValue('regions', $event)"
      />
    </v-col>
  </v-row>
</template>

<script>
import { dateFormat } from '@/modules/_global/filters';
import {
  requiredTextLine65,
  requiredSelectArray
} from '@/modules/_global/variables/rules';
import formEditable from '@/modules/_global/mixins/form-editable';
import moment from 'moment';
import DatePickerSelect from '@/modules/holidays/components/forms/Date/DatePickerSelect';

export default {
  name: 'HolidayForm',

  filters: {
    dateFormat
  },

  components: {
    DatePickerSelect,
    RegionInput: () =>
      import('@/modules/_global/_components/region/RegionInput')
  },

  mixins: [formEditable],

  data() {
    return {
      form: {
        day: undefined,
        month: undefined,
        year: undefined,
        is_all_regions: true
      },
      rules: {
        title: requiredTextLine65,
        regions: requiredSelectArray
      },
      menuDate: false
    };
  },

  computed: {
    specifyRegions() {
      return !this.form.is_all_regions;
    }
  },

  created() {
    if (this.form.date) {
      let date = moment(this.form.date);
      this.form.year = date.format('YYYY');
      this.form.month = date.format('MM');
      this.form.day = date.format('DD');
    }
  },

  methods: {
    changeRegions(v) {
      this.form.is_all_regions = !v;
      this.form.regions = [];
    }
  }
};
</script>
